import { Component, OnDestroy } from '@angular/core';

import { BaseGridComponent } from '../base-grid.component';
import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { MiscUtil } from 'src/shared/utilities/misc.util';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { StaffingGridUtil } from '../../utilities/staffing-grid.util';

@Component({
    selector: 'smt-base-shiftblock-grid',
    templateUrl: './base-shiftblock-grid.component.html',
    styleUrls: ['./base-shiftblock-grid.component.scss']
})
export class BaseShiftBlockGridComponent extends BaseGridComponent implements OnDestroy {
    copyShiftBlocks: ShiftBlock[];
    
    shiftBlocks: ShiftBlock[];

    private readonly hoursInDay = 24;    

    constructor(private _baseShiftBlockGridCostCenterConfigurationService: CostCenterConfigurationService) {
        super(_baseShiftBlockGridCostCenterConfigurationService);        
    }

    private setShiftBlockLabels() {  
        this.shiftBlocks.sort(s => s.startHour).forEach(s => {
            s.description = MiscUtil.getShiftBlockDescription(s.startHour, s.endHour);
        });
    }

    private setShiftBlocks(shiftBlocks: ShiftBlock[]) {
        if (shiftBlocks) {
            this.setShiftBlockLabels();            
        }
        else {
            shiftBlocks = [];
        }
    }

    setShiftBlocksFromSchedule() {
        this.shiftBlocks = StaffingGridUtil.setPartialShiftBlocks(this.shiftSchedule);
        
        this.setShiftBlocks(this.shiftBlocks);
    }        

    setShiftBlocksFromCopy() {
        this.copyShiftBlocks = StaffingGridUtil.setPartialShiftBlocks(this.copySource);  
        
        this.setShiftBlocks(this.copyShiftBlocks);
    }
}
